import styled from 'styled-components';
import ItineraryBiddingCell from './ItineraryBiddingCell';

export default styled(ItineraryBiddingCell)`
  cursor: pointer;
  position: relative;
  svg {
    fill: var(--grey300);
  }

  &.has_bids {
    svg {
      fill: var(--primary500);
    }
  }

  .new_bids_icon {
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background: red;
    position: absolute;
    top: 0;
    right: -3px;
  }
`;
